import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { QuoteViewerService } from "src/app/core/services/quote-viewer.service";

@Component({
	selector: "app-quote-terms-and-conditions",
	templateUrl: "./quote-terms-and-conditions.component.html",
	styleUrls: ["./../quote-viewer.scss"],
})
export class QuoteTermsAndConditionsComponent implements OnInit {
	constructor(public app: AppService, public quoteService: QuoteViewerService) {}

	ngOnInit(): void {}
}
